/*******************************************************************************
 * Copyright     : Copyright (c)  2024 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc.No part may be reproduced or transmitted in any form by any
 *                 means or for anypurpose without the express written permission of Honeywell. *
 *******************************************************************************/
import { Badge, TextOverflow, ToastMessage } from '@forge/common';
import React from 'react';
import './index.scss';

interface ToastProps {
  id: string;
  showClose: boolean;
  showDismiss: boolean;
  title: string;
  type: 'success' | 'error' | 'warning' | 'progress'; 
  subtitle: string; 
  content: string;
  lifetime?: number; 
}

const DEFAULT_LIFETIME_VALUE = 5000;

const badgeLabels: { [key: string]: string } = {
  success: 'SUCCESS',
  error: 'ERROR',
  warning: 'WARNING',
  progress: 'IN PROGRESS'
};

const Toast: React.FC<ToastProps> = ({
  id,
  showClose,
  showDismiss,
  title,
  type,
  subtitle,
  content,
  lifetime = DEFAULT_LIFETIME_VALUE 
}) => {
  const badgeType = (
    <Badge type={type}>
      {badgeLabels[type]}
    </Badge>
  );

  const args = {
    content,
    lifetime,
    id,
    showClose,
    showDismiss,
    title: (
      <div className="toast-title">
        {title}
      </div>
    ),
    type: badgeType,
    subtitle: (
      <div className="toast-subtitle">
        <TextOverflow
          lines={2}
          resizeDebounceDelay={300}
          tooltipPosition="top"
        >
          {subtitle} 
        </TextOverflow>
      </div>
    )
  };

  return <ToastMessage {...args} />;
};

export default Toast;
